<template>
    <div class="calendar-area">
        <div class="container-fluid">
            <div class="row">
                <!-- Calendário -->
                <div class="col-lg-8">
                    <div class="calendar-wrap style-two">
                        <Qalendar :selected-date="new Date()" :events="calendarEvents" :config="config" />
                    </div>
                </div>

                <!-- Painel lateral: lista + criar/editar -->
                <div class="col-lg-4">
                    <div class="performance-date">
                        <div class="main-title d-flex justify-content-between align-items-center mb-3">
                            <h3>Eventos</h3>
                            <button class="btn-primary-grad btn-sm-grad" @click="openCreate">
                                <i class="ri-add-line"></i> Novo
                            </button>
                        </div>

                        <div v-if="loading" class="text-center py-4">
                            <div class="spinner-border text-primary spinner-border-sm"></div>
                        </div>
                        <div v-if="error" class="alert-error mb-3 small">{{ error }}</div>

                        <ul v-if="!loading" class="performance-date-list">
                            <li v-if="items.length === 0" style="list-style:none;text-align:center;color:#9ca3af;">
                                Sem eventos registados.
                            </li>
                            <li v-for="item in items" :key="item.id">
                                <div class="event-card-item">
                                    <div class="event-card-item__media">
                                        <template v-if="item.coverImageUrl">
                                            <video v-if="isVideo(item.coverImageUrl)" :src="item.coverImageUrl"
                                                class="media-preview"></video>
                                            <img v-else :src="item.coverImageUrl" class="media-preview" />
                                        </template>
                                        <div v-else class="media-placeholder">
                                            <i class="ri-calendar-line"></i>
                                        </div>
                                    </div>
                                    <div class="event-card-item__info">
                                        <h3>{{ item.title_pt }}
                                            <span>{{ formatDate(item.date) }}</span>
                                        </h3>
                                        <p v-if="item.location" class="mb-1 small text-muted">
                                            <i class="ri-map-pin-line"></i> {{ item.location }}
                                        </p>
                                        <div class="d-flex gap-2 mt-2">
                                            <button class="btn-icon edit btn-icon-sm" @click="openEdit(item)"><i
                                                    class="ri-edit-line"></i></button>
                                            <button class="btn-icon text-info btn-icon-sm" @click="openRegistrants(item)" title="Ver Inscritos"><i
                                                    class="ri-group-line"></i></button>
                                            <button class="btn-icon delete btn-icon-sm" @click="confirmDelete(item)"><i
                                                    class="ri-delete-bin-line"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Criar / Editar -->
        <div v-if="showModal" class="crud-modal-overlay" @click.self="closeModal">
            <div class="crud-modal">
                <div class="crud-modal-header">
                    <h3>{{ editing ? 'Editar Evento' : 'Novo Evento' }}</h3>
                    <button class="btn-close-modal" @click="closeModal"><i class="ri-close-line"></i></button>
                </div>
                <form @submit.prevent="save" class="crud-modal-body">
                    <div class="row g-3">
                        <div class="col-12">
                            <label>Título (PT) *</label>
                            <input v-model="form.title_pt" class="form-input" required />
                        </div>
                        <div class="col-12">
                            <label>Título (EN)</label>
                            <input v-model="form.title_en" class="form-input" />
                        </div>
                        <div class="col-12">
                            <label>Descrição (PT) *</label>
                            <textarea v-model="form.description_pt" class="form-input" rows="3" required></textarea>
                        </div>
                        <div class="col-12">
                            <label>Descrição (EN)</label>
                            <textarea v-model="form.description_en" class="form-input" rows="3"></textarea>
                        </div>
                        <div class="col-6">
                            <label>Data *</label>
                            <input v-model="form.date" class="form-input" type="datetime-local" required />
                        </div>
                        <div class="col-6">
                            <label>Local</label>
                            <input v-model="form.location" class="form-input" placeholder="Ex: Luanda" />
                        </div>
                        <div class="col-12">
                            <label>Imagem de Capa</label>
                            <ImageUpload :value="form.coverImageUrl" @update:value="form.coverImageUrl = $event" />
                        </div>
                        <!-- Push Notification -->
                        <div class="col-12 mt-3" v-if="!editing">
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" id="sendPush" v-model="form.sendPush">
                                <label class="form-check-label ms-2" for="sendPush">
                                    Enviar Push Notification para todos os dispositivos
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="crud-modal-footer mt-4">
                        <button type="button" class="btn-secondary" @click="closeModal">Cancelar</button>
                        <button type="submit" class="btn-primary-grad" :disabled="saving">
                            <span v-if="saving"><i class="ri-loader-4-line spin"></i> A guardar...</span>
                            <span v-else>{{ editing ? 'Guardar' : 'Criar' }}</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <!-- Confirmação de Eliminar -->
        <div v-if="showDelete" class="crud-modal-overlay" @click.self="showDelete = false">
            <div class="crud-modal crud-modal--sm">
                <div class="crud-modal-header">
                    <h3>Eliminar Evento</h3>
                    <button class="btn-close-modal" @click="showDelete = false"><i class="ri-close-line"></i></button>
                </div>
                <div class="crud-modal-body">
                    <p>Tem a certeza que quer eliminar <strong>{{ selectedItem?.title_pt }}</strong>?</p>
                </div>
                <div class="crud-modal-footer">
                    <button class="btn-secondary" @click="showDelete = false">Cancelar</button>
                    <button class="btn-danger" @click="deleteItem" :disabled="saving">Eliminar</button>
                </div>
            </div>
        </div>

        <!-- Modal Inscritos -->
        <div v-if="showRegistrants" class="crud-modal-overlay" @click.self="showRegistrants = false">
            <div class="crud-modal">
                <div class="crud-modal-header">
                    <h3>Inscritos: {{ selectedItem?.title_pt }}</h3>
                    <button class="btn-close-modal" @click="showRegistrants = false"><i class="ri-close-line"></i></button>
                </div>
                <div class="crud-modal-body" style="max-height: 400px; overflow-y: auto;">
                    <div v-if="loadingRegistrants" class="text-center py-3">
                        <div class="spinner-border text-primary spinner-border-sm"></div>
                    </div>
                    <div v-else-if="registrants.length === 0" class="text-muted text-center py-3">
                        Nenhum inscrito até ao momento.
                    </div>
                    <ul class="list-group" v-else>
                        <li v-for="r in registrants" :key="r.id" class="list-group-item">
                            <strong class="d-block">{{ r.name }}</strong>
                            <small class="text-muted">{{ r.email }} <span v-if="r.phone">| {{ r.phone }}</span></small>
                            <br/><small class="text-secondary">Registado em: {{ new Date(r.createdAt).toLocaleString('pt-PT') }}</small>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Qalendar } from "qalendar";
import eventsService from '../../services/eventsService';
import ImageUpload from '../Common/ImageUpload.vue';

export default {
    name: 'CalendarContent',
    components: { Qalendar, ImageUpload },

    data() {
        return {
            items: [],
            loading: true,
            saving: false,
            error: '',
            showModal: false,
            showDelete: false,
            showRegistrants: false,
            editing: false,
            selectedItem: null,
            registrants: [],
            loadingRegistrants: false,
            form: { title_pt: '', title_en: '', description_pt: '', description_en: '', date: '', location: '', coverImageUrl: '', sendPush: false },
            config: {
                defaultMode: "month",
                style: {
                    colorSchemes: {
                        ggmf: { color: "#fff", backgroundColor: "#1765FD" },
                    },
                },
            },
        };
    },

    computed: {
        calendarEvents() {
            return this.items.map(e => ({
                id: e.id,
                title: e.title_pt,
                time: { start: e.date.split('T')[0], end: e.date.split('T')[0] },
                colorScheme: 'ggmf',
            }));
        },
    },

    mounted() { this.load(); },

    methods: {
        isVideo(url) {
            if (!url) return false;
            const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov'];
            return videoExtensions.some(ext => url.toLowerCase().includes(ext));
        },
        async load() {
            this.loading = true; this.error = '';
            try {
                const res = await eventsService.getAll(1, 50);
                this.items = res.data || res;
            } catch { this.error = 'Erro ao carregar eventos.'; }
            finally { this.loading = false; }
        },
        formatDate(d) { return d ? new Date(d).toLocaleDateString('pt-PT') : '—'; },
        openCreate() {
            this.editing = false;
            this.form = { title_pt: '', title_en: '', description_pt: '', description_en: '', date: '', location: '', coverImageUrl: '', sendPush: false };
            this.showModal = true;
        },
        openEdit(item) {
            this.editing = true; this.selectedItem = item;
            const dt = item.date ? item.date.replace('Z', '').substring(0, 16) : '';
            this.form = {
                title_pt: item.title_pt, title_en: item.title_en || '',
                description_pt: item.description_pt, description_en: item.description_en || '',
                date: dt, location: item.location || '', coverImageUrl: item.coverImageUrl || '',
            };
            this.showModal = true;
        },
        closeModal() { this.showModal = false; },
        async save() {
            this.saving = true;
            try {
                const payload = { ...this.form, date: new Date(this.form.date).toISOString() };
                if (this.editing) await eventsService.update(this.selectedItem.id, payload);
                else await eventsService.create(payload);
                this.closeModal(); this.load();
            } catch { this.error = 'Erro ao guardar evento.'; }
            finally { this.saving = false; }
        },
        confirmDelete(item) { this.selectedItem = item; this.showDelete = true; },
        async deleteItem() {
            this.saving = true;
            try {
                await eventsService.remove(this.selectedItem.id);
                this.showDelete = false; this.load();
            } catch { this.error = 'Erro ao eliminar evento.'; }
            finally { this.saving = false; }
        },
        async openRegistrants(item) {
            this.selectedItem = item;
            this.showRegistrants = true;
            this.loadingRegistrants = true;
            this.registrants = [];
            try {
                this.registrants = await eventsService.getRegistrations(item.id);
            } catch (err) {
                console.error("Erro ao procurar inscritos", err);
            } finally {
                this.loadingRegistrants = false;
            }
        },
    },
};
</script>

<style lang="scss">
@import '../Dashboards/GgmfDashboard/ggmf-card';

.calendar-area {
    .calendar-month__weekday[data-v-cd3b00be] {
        height: 135px !important;
    }
}

.performance-date {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 2px 15px #00000005;
    border-radius: 30px;
    padding: 30px;
    margin-bottom: 24px;
}

.performance-date-list {
    padding-left: 30px;
    margin-bottom: 0;
    list-style-type: none;
    position: relative;

    &::before {
        content: "";
        position: absolute;
        top: 65px;
        left: 0;
        width: 1px;
        height: 79%;
        border-left: 1px dashed #CAD6F2;
    }

    li {
        display: inline-block;
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 5px 25px #CAD6F266;
        border: 1px solid #DFE9FF;
        border-radius: 20px;
        padding: 20px;
        position: relative;
        margin-bottom: 20px;
        width: 100%;

        &:last-child {
            margin-bottom: 0;
        }

        &::before {
            content: "";
            position: absolute;
            top: 50%;
            left: -38px;
            width: 14px;
            height: 14px;
            border-radius: 50px;
            background-color: #1765FD;
            transform: translateY(-50%);
        }

        &::after {
            content: "";
            position: absolute;
            top: 50%;
            left: -43px;
            width: 24px;
            height: 24px;
            border-radius: 50px;
            border: 1px solid #EBF1FF;
            transform: translateY(-50%);
        }

        .event-card-item {
            display: flex;
            gap: 12px;
            align-items: center;

            &__media {
                width: 60px;
                height: 60px;
                border-radius: 12px;
                overflow: hidden;
                background: #f3f4f6;
                flex-shrink: 0;

                .media-preview {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                .media-placeholder {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #9ca3af;
                    font-size: 20px;
                }
            }

            &__info {
                flex: 1;
                min-width: 0;
            }
        }

        h3 {
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 6px;

            span {
                font-size: 12px;
                font-weight: 500;
                color: #1765FD;
                margin-left: 6px;
            }
        }
    }
}

.btn-sm-grad {
    padding: 6px 14px !important;
    font-size: 12px !important;
    border-radius: 8px !important;
}

.btn-icon-sm {
    width: 28px !important;
    height: 28px !important;
    font-size: 14px !important;
}

.calendar-month__event {
    background-image: linear-gradient(to bottom, #1765fd, #4fcb8d);
    width: auto !important;

    &.is-draggable[data-v-7bf10a44] {
        justify-content: center;
    }

    .calendar-month__event-color[data-v-7bf10a44] {
        display: none;
    }

    .calendar-month__event-title {
        color: var(--white-color);
        font-size: 9px;
    }
}

.calendar-month__event[data-v-7bf10a44] {
    display: inline-block !important;
    padding: 0 3px !important;
    --event-inline-padding: 0;
}

.qalendar-is-small {
    .calendar-month {
        .calendar-month__week[data-v-25c5b5f2] {
            display: inherit !important;
        }

        .calendar-month__weekday[data-v-cd3b00be] {
            min-height: auto !important;
        }
    }
}

.calendar-header[data-v-6976f31b] {
    display: block;
}

.calendar-month__weekday[data-v-cd3b00be] {
    height: 73px !important;
}

.calendar-root-wrapper {
    height: auto !important;
    min-height: auto !important;
}

.calendar-wrap {
    background-color: var(--white-color);
    box-shadow: var(--box-shadow);
    padding: 20px;
    border-radius: var(--border-radius);

    &.style-two {
        border-radius: 30px;
        margin-bottom: 24px;
    }
}

@media only screen and (max-width: 767px) {
    .calendar-area {
        .calendar-month__weekday[data-v-cd3b00be] {
            height: 73px !important;
        }
    }

    .performance-date {
        padding: 20px;
    }

    .performance-date-list {
        padding-left: 20px;

        &::before {
            height: 100%;
            top: 0;
        }

        li {
            padding: 15px;

            &::after {
                left: -32px;
            }

            &::before {
                left: -27px;
            }
        }
    }
}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
    .performance-date-list {
        &::before {
            height: 100%;
            top: 0;
        }
    }
}

@media only screen and (min-width: 1200px) and (max-width: 1399px) {
    .performance-date-list {
        &::before {
            height: 100%;
            top: 0;
        }
    }
}
</style>
